import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
//primereact
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Panel from "../../../components/panel/panel";
import Input from "../../../components/input/Input";
import Modal from "../../../components/modal/Modal";
import ExportTable from "../../../components/button/ExportButton";
//utils
import { queryClient } from "../../../utils/queryClient";
import { formatIsoDate } from "../../../utils/formatDate";
//services
import { putPaymentMethods } from "../../../services/Settings/PaymentMethods/putPaymentMethods";
import { deletePaymentMethods } from "../../../services/Settings/PaymentMethods/deletePaymentMethods";
import { Skeleton } from "primereact/skeleton";
import { useAppContext } from "../../../context/AppContext";

export const TableData = ({ dataTable, loading, setLoading }) => {
  const { permissions } = useAppContext();
  const form = useForm();
  const errors = form.formState.errors;

  const [id, setId] = useState(null);
  const [visible, setVisible] = useState(false);
  const [tableToExport, setTableToExport] = useState(null);

  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const columns = [
    { field: "id", header: "ID" },
    { field: "name", header: "Descrição" },
    // { field: "fee", header: "Taxa" },
    {
      field: "created_at",
      header: "Criado em",
      body: (rowData) =>
        rowData.created_at && formatIsoDate(rowData.created_at),
    },
    {
      field: "updated_at",
      header: "Atualizado em",
      body: (rowData) =>
        rowData.updated_at && formatIsoDate(rowData.updated_at),
    },
  ];

  const exportColumns = [
    { dataKey: "id", title: "ID" },
    { dataKey: "name", title: "Descrição" },
  ];

  // put
  const handleEdit = (rowData) => {
    setVisible(true);

    setId(rowData.id);
    form.setValue("name", rowData.name);
  };

  // put cost center
  const { mutateAsync: putPaymentMethodsFn } = useMutation({
    mutationFn: putPaymentMethods,
    onSuccess(_, variables) {
      variables.id = id;
      queryClient.setQueryData(["payment-methods"], (data) => {
        const updatedTable = data.map((item) => {
          if (item.id === id) {
            item.name = variables.name;
          }

          return item;
        });

        return [...updatedTable];
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  // delete cost center
  const { mutateAsync: deletePaymentFn } = useMutation({
    mutationFn: deletePaymentMethods,
    onSuccess(_, variables) {
      //      console.log(variables);
      queryClient.setQueryData(["payment-methods"], (data) => {
        const updatedTable = data.filter((item) => item.id !== variables);

        return [...updatedTable];
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  // delete cost
  const handleDelete = (id) => {
    confirmDialog({
      message: "Deseja fazer a exclusão?",
      header: "Confirmação",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => deleteCost(id),
    });
  };

  const deleteCost = async (id) => {
    setLoading(true);

    const notification = toast.loading("Deletando...");
    try {
      const response = await deletePaymentFn(id);
      //      console.log(response);

      toast.update(notification, {
        render: response.success,
        type: "success",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } catch (e) {
      //      console.log(e);
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } finally {
      setLoading(false);
      setVisible(false);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    //    console.log(data);

    data.id = id;

    try {
      const response = await putPaymentMethodsFn(data);
      //      console.log(response);

      form.reset();

      toast.success(response.success);
    } catch (e) {
      //      console.log(e);
      toast.error("Ocorreu um erro ao editar o método de pagamento!");
    } finally {
      setLoading(false);
      setVisible(false);
    }
  };

  useEffect(() => {
    if (dataTable) {
      const dataWithoutIds = dataTable.map((t) => ({
        ID: t.id,
        Descricao: t.name,
        CriadoEm: t.created_at,
        AtualizadoEm: t.updated_at,
      }));
      setTableToExport(dataWithoutIds);
    }
  }, [dataTable]);

  return (
    <Panel mainCss="mt-4" title="Métodos de Pagamento">
      {!dataTable ? (
        <Skeleton variant="rect" width="100%" height={300} />
      ) : (
        <>
          <div className="px-2 pb-3">
            <ExportTable
              tableData={tableToExport}
              exportColumns={exportColumns}
              tabelaKey="Modos de Pagamento"
              globalFilterValue={globalFilterValue}
              onGlobalFilterChange={(e) => setGlobalFilterValue(e.target.value)}
            />
            <DataTable
              rows={5}
              paginator
              stripedRows
              showGridlines
              sortMode="multiple"
              selectionMode="single"
              globalFilter={globalFilterValue}
              rowsPerPageOptions={[5, 25, 100]}
              value={dataTable}
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
            >
              {columns.map((col, i) => (
                <Column
                  sortable
                  body={col.body}
                  key={i}
                  style={{ minWidth: 150 }}
                  field={col.field}
                  header={col.header}
                />
              ))}
              {permissions &&
                permissions.includes("158") && ( // Editar metodos de pagamento
                  <Column
                    header="Alterar"
                    body={(rowData) => (
                      <div className="text-center">
                        <button
                          disabled={loading}
                          className="btn btn-success btn-btn-sm"
                          onClick={() => handleEdit(rowData)}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                      </div>
                    )}
                  />
                )}
              {permissions &&
                permissions.includes("159") && ( // Excluir metodos de pagamento
                  <Column
                    header="Remover"
                    body={(rowData) => (
                      <div className="text-center">
                        <button
                          disabled={loading}
                          className="btn btn-danger btn-btn-sm"
                          onClick={() => handleDelete(rowData.id)}
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      </div>
                    )}
                  />
                )}
            </DataTable>
          </div>

          <Modal
            visible={visible}
            dynamicTitle={"Editar método de pagamento"}
            onHide={() => setVisible(false)}
            closable={true}
            dynamicWidth={{ width: window.innerWidth <= 992 ? "85vw" : "25vw" }}
          >
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <div className="row px-3">
                <div className="col-md-12 col-sm-12 mb-3">
                  <Input
                    isRequired={true}
                    control={form.control}
                    name="name"
                    className="w-100"
                    errors={errors}
                    label="Descrição"
                  />
                </div>
                <div className="col-md-12 text-center col-sm-1 pt-3">
                  <Button
                    rounded
                    type="submit"
                    loading={loading}
                    label="Editar"
                    icon="fa fa-plus"
                    className="p-inputtext-sm m-auto"
                  />
                </div>
              </div>
            </form>
          </Modal>
        </>
      )}
    </Panel>
  );
};
